/**
 * Dépôt industriel de fichiers de reprise (ARTO-129, spec du 11 octobre 2026
 * § 8.1) : ce que l'API, la console et la page publique de la régie doivent
 * compter de la même façon. Un écart d'un octet sur la taille d'un morceau et
 * le stockage refuse l'envoi : la taille est SIGNÉE dans l'URL de chaque partie.
 */
/** Taille d'un morceau : 16 Mio, le dernier excepté. */
export const TAILLE_MORCEAU_DEPOT = 16 * 1024 * 1024;
/** Morceaux envoyés en même temps par un navigateur. */
export const ENVOIS_PARALLELES_DEPOT = 4;
/** Plafond d'un dépôt quand rien n'est précisé : 50 Gio. */
export const PLAFOND_DEPOT_DEFAUT_OCTETS = 50 * 1024 ** 3;
/** Plafond maximal qu'on peut régler sur un dépôt ou un lien : 200 Gio. */
export const PLAFOND_DEPOT_MAX_OCTETS = 200 * 1024 ** 3;
/** Durée de vie d'un lien de dépôt, et son maximum (arbitrage A5). */
export const DUREE_LIEN_DEPOT_JOURS = 14;
/** Nombre de morceaux d'un fichier ; un fichier vide n'en a aucun. */
export function nombreDeMorceaux(octets) {
    return Math.ceil(octets / TAILLE_MORCEAU_DEPOT);
}
/** Taille exacte du morceau `numero` (à partir de 1) d'un fichier de `octets`. */
export function tailleDuMorceau(octets, numero) {
    const total = nombreDeMorceaux(octets);
    if (!Number.isInteger(numero) || numero < 1 || numero > total)
        return 0;
    return numero < total ? TAILLE_MORCEAU_DEPOT : octets - TAILLE_MORCEAU_DEPOT * (total - 1);
}
//# sourceMappingURL=depot.js.map